<script setup>
import Spinner from '#common/components/Loading/Spinner.vue'

const props = defineProps({
  initial: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <div v-if="props.initial" class="loading-page">
    <Spinner />
  </div>
</template>
